import Lenis from 'lenis';

export function initSmoothScroll() {
	if ( window.matchMedia( '(prefers-reduced-motion: reduce), (max-width: 63.9375em)' ).matches ) {
		return;
	}

	const gsap = window.gsap;
	if ( ! gsap ) {
		return;
	}

	const lenis = new Lenis( {
		duration: 1.05,
		easing: ( value ) => 1 - ( 1 - value ) ** 4,
		smoothWheel: true,
		wheelMultiplier: 0.9,
		syncTouch: false,
	} );

	const update = ( time ) => lenis.raf( time * 1000 );
	gsap.ticker.add( update );
	gsap.ticker.lagSmoothing( 0 );
	lenis.on( 'scroll', () => window.ScrollTrigger?.update() );

	window.addEventListener( 'pagehide', ( event ) => {
		if ( event.persisted ) {
			return;
		}

		gsap.ticker.remove( update );
		lenis.destroy();
	}, { once: true } );
}
